import { ReactNode } from "react";
import { Fmulinje, KursusholdDto } from "../../interfaces/schema";

export type FirstItem = { inputValue: string };

export interface FirmaAutoCompleteResponse {
  id: string;
  navn1: string;
  navn2: string;
  firmaNr: number;
  kommuneNr: string;
  aktiv: boolean;
  firmatype: string;
  cvrNr: number;
}

export interface LinjeAutoCompleteResponse {
  id: string;
  navn: string;
  nr: number;
  __typename: Fmulinje["__typename"];
}
export interface KursusAutoCompleteResponse {
  id: string;
  navn: string;
  holdNr: number;
  kursustype: number;
  fmukursusKategoriNavigation: {
    navn: string;
  } | null;
  __typename: KursusholdDto["__typename"];
}

export function isKursusAutoCompleteResponse(
  obj: LinjeAutoCompleteResponse | KursusAutoCompleteResponse,
): obj is KursusAutoCompleteResponse {
  return obj.__typename === "KursusholdDTO";
}

export interface PersonAutoCompleteResponse {
  id: string;
  fuldtNavn: string;
  personart: string;
  erUdoevende: boolean;
  personFirma: {
    id: string;
    periode: {
      tilDatoInklusiv: string;
    };
    firma: {
      navn1: string;
    };
  }[];
  primaerPersonFirmaRelation: {
    id: string;
    firma: {
      navn1: string;
    };
  };
  kundeNr: number;
}
export interface PersonByFirstNameLastNameResponse extends PersonAutoCompleteResponse {
  foedselsDato: string;
}

export type AutoCompleteItem<Data = void> = {
  id: string;
  header: string;
  subheader?: string;
  icon?: ReactNode;
  href?: string;
  data?: Data;
  type?: string;
};

export interface FuldmaegtigeForPersonResponse {
  person: {
    id: string;
    personPrincipalPersonPrincipalNavigation: {
      id: string;
      periode: {
        fraDato: string;
        tilDatoInklusiv: string;
      };
    }[];
  };
}
